import { AfterViewInit, Component, EventEmitter, Input, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap/modal';
import { BaseService } from '../../Services/base.service';
import { ServiceLocator } from '../../Services/locator.service';
import { BizDatatableComponent } from '../biz-datatable/biz-datatable.component';
import { Enum } from '../config';

@Component({
    selector: 'ppd-lookup',
    templateUrl: 'ppd-lookup.component.html',
})
export class PpdLookupComponent implements OnInit, AfterViewInit {
    @Input() defaultValues: any[] = [];
    @Input() rows: any[] = [];
    @Input() headerHeight: number = 30;
    @Input() returnObject: any = {};
    @Input() scrollbarH: boolean = true;
    @Input() footerHeight: number = 50;
    @Input() limit: number = 10;
    @Input() hideEdit: boolean = true;
    @Input() hideView: boolean = false;
    @Input() hideDelete: boolean = true;
    @Input() columnMode: string = Enum.ColumnMode.standard;
    @Input() pagination: boolean = true;
    @Input() caption: string = "LOT";
    @Input() rowIndex: any;
    @Input() row: any;
    @Input() isdependent: any;
    itemOptionsOrders: any;
    itemOrder: any;
    buttonDisabled = false;
    buttonState = '';
    @Input()
    apiController: string = "";

    @Input()
    apiRoute: string = "";

    @Input()
    apiModuleName: string = "";

    @Input()
    params: any[] = [];
    // @Input() type: number = 1;

    @Input() public selectedRows: any[] = [];

    @ViewChild('lookupModal') lookupModal: TemplateRef<any>;
    @ViewChild('table') table: BizDatatableComponent;

    public _columns: any[] = [];
    public _type: number = 4;
    modalRef: any;
    @Input()
    get columns(): any {

        return this._columns;
    }
    set columns(columns: any) {

        this._columns = columns;
    }
    @Input()
    get type(): any {
        return this._type;
    }
    set type(type: any) {
        this._type = type;
        if (type === 5 && this._columns.length > 0) {
            let selectCol = {
                prop: 'selected',
                name: '',
                sortable: false,
                canAutoResize: false,
                draggable: false,
                resizable: false,
                headerCheckboxable: true,
                checkboxable: true,
                width: 50
            };
            this._columns.splice(0, 0, selectCol);
        }
    }

    private baseService: any;

    constructor(private modalService: BsModalService) {
        this.baseService = ServiceLocator.injector.get(BaseService);
    }

    @Output()
    onClick: EventEmitter<any> = new EventEmitter<any>();

    articlelist: any[] = [];
    head: any[] = [];
    articleParams: any[] = [];

    async getLeatherPOList(suppid) {
        let val = 'suppid=' + suppid;
        await this.baseService.get('LeatherRcvdItems', 'getLeatherPOList', val, 'Leather').then(o => {
            if (o && o.length && o.length > 0) {
                o.map(i => {
                    // i.poDate = moment(i.poDate).format('DD-MMM-yyyy')
                    return i;
                })
                this.rows = o;
            }
        })
    }

    async ngOnInit() {
        this.itemOrder = { label: 'PPD #', value: 'ppdid' };
        this.itemOptionsOrders = [
            { label: 'PPD #', value: 'ppdid' },
            { label: 'Customer', value: 'cName' },
            { label: 'Leather Name', value: 'lthrNameUsedByCust' },
            { label: 'Leather Color', value: 'lthrColorUsedByCust' },
            { label: 'Size', value: 'name' },
            { label: 'Qty', value: 'qty' },
            { label: 'Rate', value: 'rate' },
        ];
        this.articleParams = [{ name: 'filed', value: 'name' }, { name: 'value', value: 'value' }]
    }

    async ngAfterViewInit() { }

    async open() {
        this.columns = [{ prop: 'ppdid', name: 'PPD #', width: 80 }, 
        { prop: 'cName', name: 'Customer', width: 150 },{ prop: 'lthrNameUsedByCust', name: 'Leather Name', width: 150 },
        { prop: 'lthrColorUsedByCust', name: 'Leather Color', width: 150 },{ prop: 'name', name: 'Size', width: 70 },
        { prop: 'qty', name: 'Qty', width: 70 },{ prop: 'rate', name: 'Rate', width: 70 }];
        let val: any;
        if (this.params) {
            for (let index = 0; index < this.params.length; index++) {
                const el = this.params[index];
                if (el.value !== "isListerdependent") {
                    val = val ? val + '&' + el.name + '=' + el.value : el.name + '=' + el.value
                } else {
                    val = val ? val + '&' + el.name + '=' + this.row[this.isdependent] : el.name + '=' + this.row[this.isdependent]
                }

            }
        }
        // if (this.row[this.isdependent]) {
            await this.baseService.get(this.apiController, this.apiRoute, val, (this.apiModuleName ? this.apiModuleName : undefined)).then(o => {
                this.rows = o;
            })
        // }
        // if (this.defaultValues && this.defaultValues.length && this.defaultValues.length > 0) {

        //     let supplier = this.defaultValues[0].supplier;
        //     if(supplier){
        //         await this.getLeatherPOList(supplier);
        //     }
        // }
        setTimeout(() => {
            this.caption = this.caption && this.caption ? this.caption : 'PPD Lookup'
            this.modalRef = this.modalService.show(this.lookupModal, {
                animated: true,
                backdrop: 'static',
                class: 'modal-lg',
            });

        }, 0);

    }

    @Input()
    public LookupId: String = "";

    Click(row) {

        let obj = {
            grid: this.table,
            row: row,
            data: this.rows
        }

        if (obj) {
            
            if (this.modalRef)
                this.modalRef.hide()
            this.onClick.emit(obj);
        }
    }

    onSelection(selection) {

        if (selection) {

        }
    }

    save() {

        if (this.selectedRows) {

            this.modalRef.hide();
            return this.selectedRows;

        }
    }

    itemsPerPageChange(e) {

    }
    tempData: any[] = []
    async searchByButton(obj) {

        if (obj && obj.value) {

            // await this.getAllLeather(3, 0, obj.item.value, obj.value)
        }

    }

    searchKeyUp(obj): void {

        const val = obj.event.target.value;

        if (val === "" && this.tempData.length > 0) {

            this.rows = [...this.tempData]
            this.tempData = [];
        }

        if (this.tempData.length === 0) this.tempData = this.rows;

        this.rows = this.rows.filter(i => i[obj.item.value].toString().toLowerCase().indexOf(val.toString().toLowerCase()) !== - 1);

    };


}

export interface LookupResult {
    lookupId: string;
    data: any;
}
